(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["compact-related-products"] && !Shopify.designMode) return;
  try {
    

(() => {

  const SELECTOR =
    '[data-tyga-compact-related]';



  function initCompactRelated(root) {

    if (!root) {
      return;
    }


    if (
      root.dataset.initialized ===
      'true'
    ) {
      return;
    }


    root.dataset.initialized =
      'true';



    const track =
      root.querySelector(
        '[data-related-track]'
      );


    const editorStatus =
      root.querySelector(
        '[data-related-editor-status]'
      );


    if (!track) {
      return;
    }



    const currentProductId =
      String(
        root.dataset.currentId || ''
      );


    const currentTitle =
      root.dataset.currentTitle || '';


    const maxProducts =
      Number(
        root.dataset.maxProducts || 8
      );


    const titleMode =
      root.dataset.titleMode ||
      'difference';


    const enableTitleFallback =
      root.dataset.titleFallback ===
      'true';


    const enableCollectionFallback =
      root.dataset.collectionFallback ===
      'true';


    const enableShopifyFallback =
      root.dataset.shopifyFallback ===
      'true';


    const minSimilarity =
      Number(
        root.dataset.minSimilarity || 50
      ) / 100;


    const showImage =
      root.dataset.showImage ===
      'true';


    const showPrice =
      root.dataset.showPrice ===
      'true';


    const onlyAvailable =
      root.dataset.onlyAvailable ===
      'true';


    const enableNudge =
      root.dataset.enableNudge ===
      'true';


    const currency =
      root.dataset.currency ||
      'GBP';


    const designMode =
      root.dataset.designMode ===
      'true';



    let userInteracted =
      false;


    let suppressClick =
      false;


    let nudgeTimer =
      null;


    let nudgeReturnTimer =
      null;


    let nudgeFrame =
      null;


    let nudgeAttempts =
      0;


    let nudgeObserver =
      null;


    let nudgeStarted =
      false;



    /* =================================
       ITEM HELPERS
    ================================== */

    function items() {

      return Array.from(
        track.querySelectorAll(
          '.tyga-compact-related__item'
        )
      );

    }



    function itemCount() {

      return items().length;

    }



    function existingIds() {

      return new Set(

        items().map(
          item =>
            String(
              item.dataset.productId || ''
            )
        )

      );

    }



    /* =================================
       TITLE MATCHING
    ================================== */

    function normaliseWord(word) {

      return String(word || '')

        .normalize('NFD')

        .replace(
          /[\u0300-\u036f]/g,
          ''
        )

        .toLowerCase()

        .replace(
          /[^a-z0-9]/g,
          ''
        );

    }



    function rawWords(title) {

      return (
        String(title || '')

          .replace(
            /[–—]/g,
            '-'
          )

          .match(
            /[A-Za-z0-9]+(?:\.[0-9]+)?/g
          ) ||
        []
      );

    }



    function identifyingTokens(title) {

      const ignored =
        new Set([

          'a',
          'an',
          'and',
          'the',
          'with',
          'for',
          'of',
          'to',
          'in',
          'on',
          'by',
          'from',

          'pack',
          'packs',
          'pair',
          'pairs',
          'pc',
          'pcs',
          'piece',
          'pieces',
          'pk',

          'black',
          'blue',
          'grey',
          'gray',
          'red',
          'green',
          'pink',
          'white',
          'beige',
          'brown',
          'orange',
          'purple',
          'yellow',
          'navy',
          'silver',
          'gold',
          'clear',
          'transparent',

          'small',
          'medium',
          'large',
          'xs',
          'xl',
          'xxl'

        ]);


      return rawWords(title)

        .map(
          normaliseWord
        )

        .filter(
          Boolean
        )

        .filter(
          word =>
            !ignored.has(word)
        )

        .filter(
          word =>
            !/^\d+$/.test(word)
        );

    }



    function titleSimilarity(
      candidateTitle
    ) {

      const current =
        new Set(
          identifyingTokens(
            currentTitle
          )
        );


      const candidate =
        new Set(
          identifyingTokens(
            candidateTitle
          )
        );


      if (
        !current.size ||
        !candidate.size
      ) {
        return 0;
      }


      let matches =
        0;


      current.forEach(
        word => {

          if (
            candidate.has(word)
          ) {
            matches += 1;
          }

        }
      );


      return (
        matches /
        current.size
      );

    }



    /* =================================
       DISPLAY LABEL
    ================================== */

    function shortLabel(title) {

      const words =
        String(title || '')

          .trim()

          .split(/\s+/)

          .filter(Boolean);


      if (
        words.length <= 6
      ) {
        return words.join(' ');
      }


      return (
        words
          .slice(0, 6)
          .join(' ') +
        '…'
      );

    }



    function differenceLabel(
      candidateTitle
    ) {

      const candidateWords =
        rawWords(
          candidateTitle
        );


      const currentWords =
        new Set(

          rawWords(
            currentTitle
          ).map(
            normaliseWord
          )

        );


      const different =
        candidateWords.filter(
          word => {

            const normalised =
              normaliseWord(
                word
              );


            return (
              normalised &&
              !currentWords.has(
                normalised
              )
            );

          }
        );


      if (
        different.length === 1 &&
        /^\d+$/.test(
          different[0]
        )
      ) {

        const number =
          different[0].replace(
            /[.*+?^${}()|[\]\\]/g,
            '\\$&'
          );


        const match =
          candidateTitle.match(

            new RegExp(
              '(?:pack\\s+of\\s+|pack\\s+|pair\\s+of\\s+|pair\\s+)?' +
              number,
              'i'
            )

          );


        if (
          match &&
          match[0]
        ) {
          return match[0];
        }

      }


      if (
        different.length > 0 &&
        different.length <= 4
      ) {

        return different.join(' ');

      }


      return shortLabel(
        candidateTitle
      );

    }



    function displayLabel(title) {

      if (
        titleMode === 'full'
      ) {
        return title;
      }


      if (
        titleMode === 'short'
      ) {
        return shortLabel(
          title
        );
      }


      return differenceLabel(
        title
      );

    }



    function updateExistingLabels() {

      items().forEach(
        item => {

          const title =
            item.dataset.fullTitle ||
            '';


          const label =
            item.querySelector(
              '[data-related-title]'
            );


          if (
            title &&
            label
          ) {

            label.textContent =
              displayLabel(
                title
              );


            label.title =
              title;

          }

        }
      );

    }



    /* =================================
       SEARCH QUERIES
    ================================== */

    function buildSearchQueries() {

      const tokens =
        identifyingTokens(
          currentTitle
        );


      if (
        !tokens.length
      ) {
        return [];
      }


      const queries =
        [];


      const full =
        tokens
          .slice(0, 10)
          .join(' ');


      const medium =
        tokens
          .slice(0, 6)
          .join(' ');


      const short =
        tokens
          .slice(0, 4)
          .join(' ');


      const shortest =
        tokens
          .slice(0, 2)
          .join(' ');


      [
        full,
        medium,
        short,
        shortest
      ].forEach(
        query => {

          if (
            query &&
            !queries.includes(
              query
            )
          ) {

            queries.push(
              query
            );

          }

        }
      );


      return queries;

    }



    /* =================================
       PRICE
    ================================== */

    function formatDecimalPrice(
      value
    ) {

      const numeric =
        Number(
          value
        );


      if (
        !Number.isFinite(
          numeric
        )
      ) {
        return '';
      }


      try {

        return new Intl.NumberFormat(
          document.documentElement.lang ||
            'en-GB',
          {
            style:
              'currency',

            currency:
              currency
          }
        ).format(
          numeric
        );


      } catch (error) {

        return numeric.toFixed(
          2
        );

      }

    }



    function formatCentsPrice(
      value
    ) {

      const numeric =
        Number(
          value
        );


      if (
        !Number.isFinite(
          numeric
        )
      ) {
        return '';
      }


      return formatDecimalPrice(
        numeric / 100
      );

    }



    /* =================================
       TITLE SEARCH
    ================================== */

    async function fetchTitleMatches() {

      if (
        !enableTitleFallback
      ) {
        return [];
      }


      const queries =
        buildSearchQueries();


      if (
        !queries.length
      ) {
        return [];
      }


      const found =
        new Map();


      for (
        const query of queries
      ) {

        if (
          found.size >= 12
        ) {
          break;
        }


        try {

          const params =
            new URLSearchParams();


          params.set(
            'q',
            query
          );


          params.set(
            'resources[type]',
            'product'
          );


          params.set(
            'resources[limit]',
            '10'
          );


          params.set(
            'resources[limit_scope]',
            'each'
          );


          params.set(
            'resources[options][unavailable_products]',
            onlyAvailable
              ? 'hide'
              : 'last'
          );


          params.set(
            'resources[options][fields]',
            'title,product_type,variants.title'
          );


          const shopRoot =
            window.Shopify?.routes?.root ||
            '/';


          const response =
            await fetch(

              shopRoot +
              'search/suggest.json?' +
              params.toString(),

              {
                headers: {
                  Accept:
                    'application/json'
                }
              }

            );


          if (
            !response.ok
          ) {
            continue;
          }


          const json =
            await response.json();


          const products =
            json?.resources?.results?.products ||
            [];


          products.forEach(
            product => {

              const id =
                String(
                  product.id ||
                  ''
                );


              if (
                !id ||
                id ===
                  currentProductId ||
                existingIds().has(
                  id
                )
              ) {
                return;
              }


              const similarity =
                titleSimilarity(
                  product.title ||
                  ''
                );


              if (
                similarity <
                minSimilarity
              ) {
                return;
              }


              const old =
                found.get(
                  id
                );


              if (
                !old ||
                similarity >
                  old.similarity
              ) {

                let image =
                  '';


                if (
                  typeof
                    product.featured_image ===
                  'string'
                ) {

                  image =
                    product.featured_image;

                } else if (
                  product.featured_image
                ) {

                  image =
                    product.featured_image.url ||
                    product.featured_image.src ||
                    '';

                } else if (
                  typeof product.image ===
                  'string'
                ) {

                  image =
                    product.image;

                }


                found.set(
                  id,
                  {
                    id:
                      product.id,

                    title:
                      product.title ||
                      '',

                    url:
                      product.url ||
                      '',

                    image:
                      image,

                    price:
                      formatDecimalPrice(
                        product.price
                      ),

                    similarity:
                      similarity
                  }
                );

              }

            }
          );


        } catch (error) {

          /*
            Collection fallback
            remains available.
          */

        }

      }


      return Array
        .from(
          found.values()
        )
        .sort(
          (a, b) =>
            b.similarity -
            a.similarity
        );

    }



    /* =================================
       COLLECTION
    ================================== */

    function collectionCandidates() {

      const script =
        root.querySelector(
          '[data-collection-candidates]'
        );


      if (
        !script
      ) {
        return [];
      }


      try {

        const parsed =
          JSON.parse(
            script.textContent ||
            '[]'
          );


        return Array.isArray(
          parsed
        )
          ? parsed
          : [];


      } catch (error) {

        return [];

      }

    }



    /* =================================
       SHOPIFY RELATED
    ================================== */

    async function fetchShopifyRelated() {

      if (
        !enableShopifyFallback ||
        !currentProductId
      ) {
        return [];
      }


      try {

        const shopRoot =
          window.Shopify?.routes?.root ||
          '/';


        const response =
          await fetch(

            shopRoot +
            'recommendations/products.json' +
            '?product_id=' +
            encodeURIComponent(
              currentProductId
            ) +
            '&limit=10&intent=related',

            {
              headers: {
                Accept:
                  'application/json'
              }
            }

          );


        if (
          !response.ok
        ) {
          return [];
        }


        const json =
          await response.json();


        const products =
          Array.isArray(
            json?.products
          )
            ? json.products
            : [];


        return products

          .filter(
            product => {

              if (
                String(
                  product.id
                ) ===
                currentProductId
              ) {
                return false;
              }


              if (
                onlyAvailable &&
                product.available ===
                  false
              ) {
                return false;
              }


              return true;

            }
          )

          .map(
            product => {

              let image =
                '';


              if (
                typeof
                  product.featured_image ===
                'string'
              ) {

                image =
                  product.featured_image;

              } else if (
                product.featured_image
              ) {

                image =
                  product.featured_image.url ||
                  product.featured_image.src ||
                  '';

              }


              return {
                id:
                  product.id,

                title:
                  product.title ||
                  '',

                url:
                  product.url ||
                  (
                    product.handle
                      ? shopRoot +
                        'products/' +
                        product.handle
                      : ''
                  ),

                image:
                  image,

                price:
                  formatCentsPrice(
                    product.price
                  )
              };

            }
          );


      } catch (error) {

        return [];

      }

    }



    /* =================================
       APPEND PRODUCT
    ================================== */

    function appendProduct(
      product,
      source
    ) {

      if (
        !product ||
        itemCount() >=
          maxProducts
      ) {
        return false;
      }


      const id =
        String(
          product.id ||
          ''
        );


      if (
        !id ||
        id ===
          currentProductId ||
        existingIds().has(
          id
        )
      ) {
        return false;
      }


      const link =
        document.createElement(
          'a'
        );


      link.className =
        'tyga-compact-related__item';


      link.href =
        product.url ||
        '#';


      link.dataset.productId =
        id;


      link.dataset.fullTitle =
        product.title ||
        '';


      link.dataset.source =
        source;


      link.draggable =
        false;



      if (
        showImage
      ) {

        const imageWrap =
          document.createElement(
            'span'
          );


        imageWrap.className =
          'tyga-compact-related__image';


        if (
          product.image
        ) {

          const image =
            document.createElement(
              'img'
            );


          image.src =
            product.image;


          image.alt =
            '';


          image.loading =
            'lazy';


          image.draggable =
            false;


          const size =
            parseInt(
              getComputedStyle(
                root
              ).getPropertyValue(
                '--tyga-related-image-size'
              ),
              10
            ) ||
            44;


          image.width =
            size;


          image.height =
            size;


          imageWrap.appendChild(
            image
          );

        }


        link.appendChild(
          imageWrap
        );

      }



      const content =
        document.createElement(
          'span'
        );


      content.className =
        'tyga-compact-related__content';



      const title =
        document.createElement(
          'span'
        );


      title.className =
        'tyga-compact-related__title';


      title.dataset.relatedTitle =
        '';


      title.textContent =
        displayLabel(
          product.title ||
          ''
        );


      title.title =
        product.title ||
        '';


      content.appendChild(
        title
      );



      if (
        showPrice &&
        product.price
      ) {

        const price =
          document.createElement(
            'span'
          );


        price.className =
          'tyga-compact-related__price';


        price.textContent =
          product.price;


        content.appendChild(
          price
        );

      }


      link.appendChild(
        content
      );


      track.appendChild(
        link
      );


      return true;

    }



    /* =================================
       COLLECTION FALLBACK
    ================================== */

    function appendCollectionFallbacks() {

      if (
        !enableCollectionFallback
      ) {
        return;
      }


      const ranked =
        collectionCandidates()

          .map(
            product => ({
              ...product,

              similarity:
                titleSimilarity(
                  product.title ||
                  ''
                )
            })
          )

          .sort(
            (a, b) =>
              b.similarity -
              a.similarity
          );


      ranked.forEach(
        product => {

          if (
            itemCount() >=
            maxProducts
          ) {
            return;
          }


          appendProduct(
            product,
            'collection'
          );

        }
      );

    }



    /* =================================
       DESKTOP CLICK + DRAG
    ================================== */

    function bindDesktopDrag() {

      let pointerId =
        null;


      let startX =
        0;


      let startScrollLeft =
        0;


      let dragging =
        false;



      track.addEventListener(
        'pointerdown',
        event => {

          /*
            Native mobile swipe stays
            completely untouched.
          */

          if (
            event.pointerType ===
            'touch'
          ) {
            return;
          }


          if (
            event.button !== 0
          ) {
            return;
          }


          cancelNudge();


          userInteracted =
            true;


          pointerId =
            event.pointerId;


          startX =
            event.clientX;


          startScrollLeft =
            track.scrollLeft;


          dragging =
            false;


          suppressClick =
            false;

        }
      );



      track.addEventListener(
        'pointermove',
        event => {

          if (
            pointerId === null ||
            event.pointerId !==
              pointerId
          ) {
            return;
          }


          const distance =
            event.clientX -
            startX;


          /*
            Quick click:
            leave it completely alone.

            Drag only starts after
            9px of mouse movement.
          */

          if (
            !dragging &&
            Math.abs(
              distance
            ) > 9
          ) {

            dragging =
              true;


            suppressClick =
              true;


            track.classList.add(
              'is-dragging'
            );


            try {

              track.setPointerCapture(
                pointerId
              );

            } catch (error) {}

          }


          if (
            !dragging
          ) {
            return;
          }


          event.preventDefault();


          track.scrollLeft =
            startScrollLeft -
            distance;

        }
      );



      const finishDrag =
        event => {

          if (
            pointerId === null
          ) {
            return;
          }


          if (
            event &&
            event.pointerId !==
              pointerId
          ) {
            return;
          }


          track.classList.remove(
            'is-dragging'
          );


          if (
            dragging
          ) {

            suppressClick =
              true;


            window.setTimeout(
              () => {

                suppressClick =
                  false;

              },
              100
            );

          }


          if (
            dragging &&
            track.hasPointerCapture?.(
              pointerId
            )
          ) {

            try {

              track.releasePointerCapture(
                pointerId
              );

            } catch (error) {}

          }


          pointerId =
            null;


          dragging =
            false;

        };



      track.addEventListener(
        'pointerup',
        finishDrag
      );


      track.addEventListener(
        'pointercancel',
        finishDrag
      );



      track.addEventListener(
        'click',
        event => {

          /*
            Only block the click if an
            actual drag happened.
          */

          if (
            suppressClick
          ) {

            event.preventDefault();

            event.stopPropagation();

          }

        },
        true
      );



      track.addEventListener(
        'dragstart',
        event => {

          event.preventDefault();

        }
      );

    }



    /* =================================
       FULL TITLE ON HOVER
    ================================== */
function bindTitleHoverScroll() {

  let titleFrame =
    null;


  function stopTitleAnimation() {

    if (
      titleFrame
    ) {

      cancelAnimationFrame(
        titleFrame
      );


      titleFrame =
        null;

    }

  }


  function animateTitle(
    title,
    target,
    duration
  ) {

    stopTitleAnimation();


    const start =
      title.scrollLeft;


    const change =
      target - start;


    const started =
      performance.now();


    function frame(now) {

      const progress =
        Math.min(
          1,
          (now - started) /
          duration
        );


      const eased =
        0.5 -
        Math.cos(
          progress *
          Math.PI
        ) / 2;


      title.scrollLeft =
        start +
        change *
        eased;


      if (
        progress < 1
      ) {

        titleFrame =
          requestAnimationFrame(
            frame
          );

      } else {

        titleFrame =
          null;

      }

    }


    titleFrame =
      requestAnimationFrame(
        frame
      );

  }


  track.addEventListener(
    'mouseover',
    event => {

      const item =
        event.target.closest(
          '.tyga-compact-related__item'
        );


      if (
        !item ||
        !track.contains(item)
      ) {
        return;
      }


      /*
        Don't restart the animation when
        moving between elements inside
        the same product button.
      */

      if (
        event.relatedTarget &&
        item.contains(
          event.relatedTarget
        )
      ) {
        return;
      }


      const title =
        item.querySelector(
          '.tyga-compact-related__title'
        );


      const fullTitle =
        item.dataset.fullTitle ||
        '';


      if (
        !title ||
        !fullTitle
      ) {
        return;
      }


      stopTitleAnimation();


      title.scrollLeft =
        0;


      title.textContent =
        fullTitle;


      requestAnimationFrame(
        () => {

          const overflow =
            title.scrollWidth -
            title.clientWidth;


          if (
            overflow <= 3
          ) {
            return;
          }


          /*
            Scroll only inside the text box.
            The image/product card never moves.
          */

          const duration =
            Math.max(
              1800,
              Math.min(
                4200,
                1500 +
                overflow * 8
              )
            );


          animateTitle(
            title,
            overflow,
            duration
          );

        }
      );

    }
  );


  track.addEventListener(
    'mouseout',
    event => {

      const item =
        event.target.closest(
          '.tyga-compact-related__item'
        );


      if (
        !item
      ) {
        return;
      }


      if (
        event.relatedTarget &&
        item.contains(
          event.relatedTarget
        )
      ) {
        return;
      }


      const title =
        item.querySelector(
          '.tyga-compact-related__title'
        );


      const fullTitle =
        item.dataset.fullTitle ||
        '';


      if (
        !title
      ) {
        return;
      }


      stopTitleAnimation();


      title.scrollLeft =
        0;


      title.textContent =
        displayLabel(
          fullTitle
        );

    }
  );

}

    /* =================================
       GENERAL INTERACTION
    ================================== */

    function bindInteraction() {

      track.addEventListener(
        'touchstart',
        () => {

          userInteracted =
            true;


          cancelNudge();

        },
        {
          passive: true
        }
      );



      track.addEventListener(
        'wheel',
        event => {

          /*
            Normal vertical page scrolling
            should NOT cancel the nudge.

            Only treat a horizontal wheel/
            trackpad gesture as interaction
            with this carousel.
          */

          if (
            Math.abs(
              event.deltaX
            ) >
            Math.abs(
              event.deltaY
            ) ||
            event.shiftKey
          ) {

            userInteracted =
              true;


            cancelNudge();

          }

        },
        {
          passive: true
        }
      );



      track.addEventListener(
        'keydown',
        event => {

          if (
            event.key !==
              'ArrowLeft' &&
            event.key !==
              'ArrowRight'
          ) {
            return;
          }


          event.preventDefault();


          userInteracted =
            true;


          cancelNudge();


          track.scrollBy({
            left:
              event.key ===
                'ArrowRight'
                ? 150
                : -150,

            behavior:
              'smooth'
          });

        }
      );

    }



    /* =================================
       SMOOTH NUDGE
    ================================== */

    function overflowing() {

      return (
        track.scrollWidth >
        track.clientWidth +
        5
      );

    }



    function animateTrackScroll(
      target,
      duration
    ) {

      if (
        nudgeFrame
      ) {

        cancelAnimationFrame(
          nudgeFrame
        );

      }


      const start =
        track.scrollLeft;


      const change =
        target -
        start;


      const started =
        performance.now();



      function frame(now) {

        if (
          userInteracted
        ) {

          nudgeFrame =
            null;

          return;

        }


        const progress =
          Math.min(
            1,
            (now - started) /
            duration
          );


        /*
          Smooth sine ease:
          slow start, smooth middle,
          slow finish.
        */

        const eased =
          0.5 -
          Math.cos(
            progress *
            Math.PI
          ) / 2;


        track.scrollLeft =
          start +
          change *
          eased;


        if (
          progress < 1
        ) {

          nudgeFrame =
            requestAnimationFrame(
              frame
            );

        } else {

          nudgeFrame =
            null;

        }

      }


      nudgeFrame =
        requestAnimationFrame(
          frame
        );

    }



    function cancelNudge() {

      if (
        nudgeTimer
      ) {

        clearTimeout(
          nudgeTimer
        );


        nudgeTimer =
          null;

      }


      if (
        nudgeReturnTimer
      ) {

        clearTimeout(
          nudgeReturnTimer
        );


        nudgeReturnTimer =
          null;

      }


      if (
        nudgeFrame
      ) {

        cancelAnimationFrame(
          nudgeFrame
        );


        nudgeFrame =
          null;

      }


      track.style.scrollSnapType =
        '';


      track.style.scrollBehavior =
        '';

    }



    function startNudgeWhenVisible() {

      if (
        !enableNudge ||
        nudgeStarted
      ) {
        return;
      }


      /*
        Fallback for browsers without
        IntersectionObserver.
      */

      if (
        !(
          'IntersectionObserver'
          in window
        )
      ) {

        nudgeStarted =
          true;


        scheduleNudge();


        return;

      }


      nudgeObserver =
        new IntersectionObserver(
          entries => {

            entries.forEach(
              entry => {

                /*
                  Begin when at least 20%
                  of the carousel is actually
                  visible in the viewport.
                */

                if (
                  entry.isIntersecting &&
                  entry.intersectionRatio >=
                    0.2
                ) {

                  nudgeStarted =
                    true;


                  nudgeObserver.disconnect();


                  nudgeObserver =
                    null;


                  /*
                    Brief pause after entering
                    the screen so the customer
                    notices the section first.
                  */

                  window.setTimeout(
                    () => {

                      if (
                        !userInteracted
                      ) {

                        scheduleNudge();

                      }

                    },
                    200
                  );

                }

              }
            );

          },
          {
            threshold: [
              0,
              0.2,
              0.5
            ]
          }
        );


      nudgeObserver.observe(
        root
      );

    }



    function scheduleNudge() {

      if (
        !enableNudge ||
        userInteracted
      ) {
        return;
      }


      if (
        window.matchMedia &&
        window.matchMedia(
          '(prefers-reduced-motion: reduce)'
        ).matches
      ) {
        return;
      }


      /*
        Images/products may still be
        finishing their layout.

        Retry for several seconds rather
        than giving up immediately.
      */

      if (
        !overflowing()
      ) {

        if (
          nudgeAttempts < 12
        ) {

          nudgeAttempts +=
            1;


          nudgeTimer =
            window.setTimeout(
              () => {

                scheduleNudge();

              },
              400
            );

        }


        return;

      }


      nudgeAttempts =
        0;


      nudgeTimer =
        window.setTimeout(
          () => {

            if (
              userInteracted ||
              !overflowing()
            ) {
              return;
            }


            const start =
              track.scrollLeft;


            const maximum =
              track.scrollWidth -
              track.clientWidth;


            const distance =
              Math.min(
                54,
                maximum -
                start
              );


            if (
              distance < 8
            ) {
              return;
            }


            /*
              Disable browser-native smoothing
              and snapping while our own RAF
              animation controls the motion.
            */

            track.style.scrollBehavior =
              'auto';


            track.style.scrollSnapType =
              'none';


            /*
              Very smooth glide outward.
            */

            animateTrackScroll(
              start +
              distance,
              550
            );


            /*
              Pause, then glide back
              even more gently.
            */

            nudgeReturnTimer =
              window.setTimeout(
                () => {

                  if (
                    userInteracted
                  ) {

                    track.style.scrollBehavior =
                      '';


                    track.style.scrollSnapType =
                      '';


                    return;

                  }


                  animateTrackScroll(
                    start,
                    700
                  );


                  window.setTimeout(
                    () => {

                      track.style.scrollBehavior =
                        '';


                      track.style.scrollSnapType =
                        '';

                    },
                    750
                  );

                },
                800
              );

          },
          250
        );

    }



    /* =================================
       LOAD PRODUCTS
    ================================== */

    async function loadProducts() {

      /*
        Priority 1:
        manual products are already
        rendered by Liquid.
      */


      /*
        Priority 2:
        similar title products.
      */

      if (
        itemCount() <
        maxProducts
      ) {

        const titleMatches =
          await fetchTitleMatches();


        titleMatches.forEach(
          product => {

            if (
              itemCount() <
              maxProducts
            ) {

              appendProduct(
                product,
                'title'
              );

            }

          }
        );

      }



      /*
        Priority 3:
        most-specific / inner collection.
      */

      if (
        itemCount() <
        maxProducts
      ) {

        appendCollectionFallbacks();

      }



      /*
        Priority 4:
        Shopify recommendation engine.
      */

      if (
        itemCount() <
        maxProducts
      ) {

        const recommendations =
          await fetchShopifyRelated();


        recommendations.forEach(
          product => {

            if (
              itemCount() <
              maxProducts
            ) {

              appendProduct(
                product,
                'shopify'
              );

            }

          }
        );

      }


      finish();

    }



    /* =================================
       FINISH
    ================================== */

    function finish() {

      root.dataset.ready =
        'true';


      updateExistingLabels();


      if (
        itemCount() > 0
      ) {

        root.hidden =
          false;


        if (
          editorStatus
        ) {

          editorStatus.hidden =
            true;

        }


        /*
          Products are ready.

          We now wait for the SECTION
          to actually enter the viewport
          before nudging.
        */

        requestAnimationFrame(
          () => {

            requestAnimationFrame(
              () => {

                startNudgeWhenVisible();

              }
            );

          }
        );


      } else if (
        designMode
      ) {

        root.hidden =
          false;


        if (
          editorStatus
        ) {

          editorStatus.hidden =
            false;


          editorStatus.textContent =
            'No matching products found for this product.';

        }


      } else {

        /*
          Live storefront:
          hide completely if nothing matched.
        */

        root.hidden =
          true;

      }

    }



    /* =================================
       INITIALISE
    ================================== */

    updateExistingLabels();


    bindDesktopDrag();


    bindInteraction();


    bindTitleHoverScroll();


    loadProducts();

  }



  function initialiseAll() {

    document
      .querySelectorAll(
        SELECTOR
      )
      .forEach(
        initCompactRelated
      );

  }


  initialiseAll();



  /*
    Reinitialise when Shopify reloads
    the section inside the theme editor.
  */

  document.addEventListener(
    'shopify:section:load',
    event => {

      const root =
        event.target.matches?.(
          SELECTOR
        )
          ? event.target
          : event.target.querySelector?.(
              SELECTOR
            );


      if (
        root
      ) {

        initCompactRelated(
          root
        );

      }

    }
  );

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
